module.exports = __webpack_public_path__ + "img/Shaman-tauren-f-70.b5e2fce1.gif";